import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { UX, UX2, constants } from '@wsb/guac-widget-core';
import PortalContainer from '../PortalContainer';
import { isDeviceMobile } from '../utils/viewDevice';
import { FLEX_FILL } from '../../../../constants/headerTreatments';

const {
  renderModes: { PUBLISH },
  layers: { Z_INDEX_EDITORS }
} = constants;

function SlideshowArrows(props) {
  const {
    numSlides,
    editingIndex,
    visible,
    containerId,
    mobileContainerId,
    nextSlide,
    prevSlide,
    viewDevice,
    renderMode,
    headerTreatment
  } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const goToPrevSlide = useCallback(
    e => {
      e.stopPropagation();
      prevSlide();
    },
    [prevSlide]
  );

  const goToNextSlide = useCallback(
    e => {
      e.stopPropagation();
      nextSlide();
    },
    [nextSlide]
  );

  const handleMatchMedia = useCallback(
    data => {
      const newIsMobile = renderMode === PUBLISH ? data.size === 'xs' : isDeviceMobile(viewDevice);
      if (!loaded || newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
        setLoaded(true);
      }
    },
    [viewDevice, renderMode, isMobile, loaded, setIsMobile, setLoaded]
  );

  if (numSlides <= 1) {
    return null;
  }

  const styles = {
    overlay: {
      'zIndex': Z_INDEX_EDITORS,
      'display': visible && loaded ? 'flex' : 'none',
      'justifyContent': 'center',
      'position': 'absolute',
      '@xs-only': {
        bottom: 0,
        left: 'small',
        right: 'small',
        marginBottom: 'small'
      },
      '@sm': {
        left: 0,
        right: 0,
        top: headerTreatment === FLEX_FILL ? 'unset' : 'calc(50% - 20px)',
        bottom: headerTreatment === FLEX_FILL ? 30 : 'unset'
      }
    }
  };

  const dataRouteProps =
    editingIndex >= 0
      ? {
        ['data-route']: '/mediaData'
      }
      : {};

  const arrowsGroup = (
    <React.Fragment>
      <UX.MatchMedia onChange={ handleMatchMedia } />
      <UX2.Group.SlideshowArrows>
        <UX2.Element.Button.Previous
          onClick={ goToPrevSlide }
          data-edit-interactive={ true }
          { ...dataRouteProps }
        />
        <UX2.Element.Button.Next
          onClick={ goToNextSlide }
          data-edit-interactive={ true }
          { ...dataRouteProps }
        />
      </UX2.Group.SlideshowArrows>
    </React.Fragment>
  );

  if (isMobile && mobileContainerId) {
    return <PortalContainer containerId={ mobileContainerId }>{ arrowsGroup }</PortalContainer>;
  }

  if (containerId) {
    return <PortalContainer containerId={ containerId }>{ arrowsGroup }</PortalContainer>;
  }

  return <UX2.Element.Block style={ styles.overlay }>{ arrowsGroup }</UX2.Element.Block>;
}

SlideshowArrows.propTypes = {
  numSlides: PropTypes.number,
  prevSlide: PropTypes.func,
  nextSlide: PropTypes.func,
  editingIndex: PropTypes.number,
  visible: PropTypes.bool,
  containerId: PropTypes.string,
  mobileContainerId: PropTypes.string,
  renderMode: PropTypes.string,
  viewDevice: PropTypes.string,
  headerTreatment: PropTypes.string
};

export default SlideshowArrows;
